const actionTypes = {
  SWITCH_LANGUAGE: 'SWITCH_LANGUAGE',
  SET_LANGUAGE_CONTENT: 'SET_LANGUAGE_CONTENT' // New action type
}

export default actionTypes;



// WEBPACK FOOTER //
// ./src/mi-app/language/action_types.js